export default {
  //endpoint: process.env.REACT_APP_BACKEND_URL ?? 'https://ferragamo-qty.temera.it/ferragamo-tmr-api/', //'https://jenkins.temera.it/ferragamo-tmr-api/',
  endpoint: process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080/ferragamo-tmr-api/', //'https://jenkins.temera.it/ferragamo-tmr-api/',
}
